export const bonusImages = {
  questMap:
    'https://cdn.magicpatterns.com/uploads/nzxTTABANUHDyQs7osuSnp/12_bonus_quest_map.png',
  rewardCards:
    'https://cdn.magicpatterns.com/uploads/wEgnuem2txb1NgzAYwTRTf/13_bonus_reward_cards.png',
}

export const bonusTools: string[] = [
  'Quest Map',
  'Reward Cards',
  'Print-and-Cut Practice Cards',
  'Certificate of Completion',
  'Times Table Wall Chart',
  '100 Chart',
  'Fluency Tracker',
  'Parent & Teacher Guide',
  'Weekly Practice Planner',
]
